export const formatPhone = (phone) => {
  if (!phone) return "";
  if (!/^\d{10}$/.test(phone)) return phone;
  return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
};

export const formatRate = (rate) => {
  if (rate === null || rate === undefined || rate === "") return null;
  return `$${Number(rate).toFixed(2)}/hr`;
};

export const PORTAL_STATUS_LABELS = {
  not_invited: "Not invited",
  invited: "Invited",
  active: "Activated",
};

export const PORTAL_STATUS_COLORS = {
  not_invited: "warning",
  invited: "gray",
  active: "success",
};

export const portalStatusLabel = (person) => {
  if (person.portal_status !== "invited" || !person.invited_at)
    return PORTAL_STATUS_LABELS[person.portal_status];
  const invitedOn = new Date(person.invited_at).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
  return `Invited ${invitedOn}`;
};

export const invitationSummary = ({ invited_ids: invitedIds, skipped }) => {
  const invited =
    invitedIds.length === 1
      ? "Invited 1 person."
      : `Invited ${invitedIds.length} people.`;
  if (skipped.length === 0) return { message: invited, skippedMessage: null };
  return {
    message: invited,
    skippedMessage: skipped
      .map((person) => `${person.name}: ${person.reason}`)
      .join(" "),
  };
};

export const COLOR_OPTIONS = [
  { value: "", label: "No color" },
  { value: "#667085", label: "Gray" },
  { value: "#D92D20", label: "Red" },
  { value: "#EF6820", label: "Orange" },
  { value: "#DC6803", label: "Amber" },
  { value: "#079455", label: "Green" },
  { value: "#0E9384", label: "Teal" },
  { value: "#1570EF", label: "Blue" },
  { value: "#444CE7", label: "Indigo" },
  { value: "#7A5AF8", label: "Purple" },
  { value: "#DD2590", label: "Pink" },
];

export const errorMessages = (error) => error?.response?.data?.errors || [];
